import { render, staticRenderFns } from "./artical-list.vue?vue&type=template&id=5dd50d99&"
import script from "./artical-list.vue?vue&type=script&lang=js&"
export * from "./artical-list.vue?vue&type=script&lang=js&"
import style0 from "./artical-list.vue?vue&type=style&index=0&id=5dd50d99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports